import React from 'react';
import { CountryDropdown } from 'react-country-region-selector';
//////////////////////////////////////////////////

const CountrySelect = (props) => {
  const { id, value, disabled, setFieldValue, setFieldTouched } = props;

  const handleBlur = () => setFieldTouched(id, true);

  const handleChange = (value) => setFieldValue(id, value);

  return (
    <CountryDropdown
      id={id}
      disabled={disabled}
      value={value || ''}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default CountrySelect;
